import * as tslib_1 from "tslib";
import { ODataGridComponent, } from '@pages/generics/grid';
import { ModalService, } from '@services';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject } from 'rxjs';
import { MLSkillsModalComponent, MLSkillVersionsModalComponent, } from './modals';
var MLSkillsPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MLSkillsPageComponent, _super);
    function MLSkillsPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            mlskillsDetails$: new BehaviorSubject(false),
        };
        _this._modalService = _this._injector.get(ModalService);
        return _this;
    }
    MLSkillsPageComponent.prototype.openModal = function (model) {
        var _this = this;
        var clone = cloneDeep(model);
        this._modalService
            .openModal(MLSkillsModalComponent, clone)
            .afterClosedResult()
            .subscribe(function (res) {
            if (res.type === 1 /* Add */) {
                _this._refresh$.next();
            }
        });
    };
    MLSkillsPageComponent.prototype.showMLSkill = function (mlskill) {
        var _this = this;
        this.loading.mlskillsDetails$.next(true);
        var clone = cloneDeep(mlskill);
        this.loading.mlskillsDetails$.next(false);
        this._modalService
            .openModal(MLSkillVersionsModalComponent, clone)
            .afterClosedResult()
            .subscribe(function (res) {
            if (res.type === 2 /* Update */) {
                _this._refresh$.next();
            }
        });
    };
    return MLSkillsPageComponent;
}(ODataGridComponent));
export { MLSkillsPageComponent };
